module.exports = __webpack_public_path__ + "static/img/banner.31179a3a.jpg";